import { makeStyles } from '@mui/styles';

export const useSalesOrderGeneralTabStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));
